
import React, { forwardRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../css/policyeditor.css";

const toolbarOptions = [
  ["bold", "italic", "underline"],
  [{ header: [1, 2, 3, false] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
];

const PolicyEditor = forwardRef(function PolicyEditor(
  { value, onChange, placeholder,isFocused,setIsFocused },
  ref
) {
  

  return (
    <div className={`quill-editor-container${isFocused ? " is-focused" : ""}`}>
      <ReactQuill
        ref={ref}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={{
          toolbar: toolbarOptions,
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "list",
          "bullet",
          "link",
        ]}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        // readOnly={readOnly}
      />
    </div>
  );
});

export default PolicyEditor;